import { Box } from '@ksyos/design-system';
import { CSSTransition } from 'react-transition-group';
import { styled } from 'styled-components';

interface IDropDownSelectCollapseProps {
    children: React.ReactNode;
    isOpen?: boolean;
    position?: number;
}

export function DropDownSelectCollapse(props: IDropDownSelectCollapseProps) {
    return (
        <CSSTransition
            classNames="select-collapse"
            in={props.isOpen}
            timeout={200}
            transitionname="select-collapse"
            unmountOnExit
        >
            <Box
                left="0"
                mt={4}
                position="absolute"
                width="100%"
                zIndex="1"
            >
                {props.position && <StyledTriangle $position={props.position} />}
                <Box
                    backgroundColor="white"
                    border="1px solid"
                    borderColor="magenta700"
                    p={[4, 8]}
                    position="relative"
                >
                    {props.children}
                </Box>
            </Box>
        </CSSTransition>
    );
}

const StyledTriangle = styled.div<{ $position?: number }>`
    position: absolute;
    top: -15px;
    transform: translateX(-50%);
    display: inline-block;
    width: 16px;
    height: 16px;
    z-index: 2;
    left: ${(props) => props.$position}px;

    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: -2px;
        display: inline-block;
        border-bottom: 10px solid ${(props) => props.theme.colors.magenta700};
        border-left: 10px solid transparent;
        border-top: 10px solid transparent;
        border-right: 10px solid transparent;
        z-index: 9999;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        display: inline-block;
        border-bottom: 8px solid #fff;
        border-left: 8px solid transparent;
        border-top: 8px solid transparent;
        border-right: 8px solid transparent;
        z-index: 9999;
    }
`;
